function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.45414 0.847656C3.61109 0.847656 0.484375 3.97437 0.484375 7.81743C0.484375 8.97111 0.772817 10.115 1.32115 11.1296L7.073 21.5323C7.14957 21.671 7.29549 21.7569 7.45414 21.7569C7.6128 21.7569 7.75872 21.671 7.83529 21.5323L13.5893 11.1262C14.1355 10.115 14.4239 8.97107 14.4239 7.81738C14.4239 3.97437 11.2972 0.847656 7.45414 0.847656ZM7.45414 11.3023C5.53262 11.3023 3.96928 9.73895 3.96928 7.81743C3.96928 5.8959 5.53262 4.33256 7.45414 4.33256C9.37567 4.33256 10.939 5.8959 10.939 7.81743C10.939 9.73895 9.37567 11.3023 7.45414 11.3023Z",
  fill: "white"
});

var SvgLocationIc = function SvgLocationIc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 22,
    viewBox: "0 0 15 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocationIc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/location_ic.ee3b9784.svg";
export { ForwardRef as ReactComponent };